module.exports = __webpack_public_path__ + "img/centerIonc5.85a0ebaf.png";